import React from "react";
import StringField from "./StringField";

const LongStringField = props => <StringField multiLine {...props} />;

export default LongStringField;



// WEBPACK FOOTER //
// ./components/common/form-field/LongStringField.js